import { createAsyncThunk } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetOutdoorBarArticleCardsByCategoryUidApiResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            slug: z.string(),
            name: z.string(),
            description: z.any().optional().nullable(),
            images: z.array(
                z.object({
                    url: z.string(),
                }),
            ).optional().nullable(),
            category: z.object({
                documentId: z.string(),
                slug: z.string(),
            }).optional().nullable(),
        }),
    ),
});

type GetOutdoorBarArticleCardsByCategoryUidActionResponse
    = ApiResponse<z.infer<typeof GetOutdoorBarArticleCardsByCategoryUidApiResponseSchema>>
    | BaseError;

type GetOutdoorBarArticleCardsByCategoryUidActionRequest = {
    categoryUid: string
}

export const getOutdoorBarArticleCardsByCategoryUid = createAsyncThunk<
    GetOutdoorBarArticleCardsByCategoryUidActionResponse,
    GetOutdoorBarArticleCardsByCategoryUidActionRequest
>(
    'OutdoorBarsPageActionsGetOutdoorBarArticleCardsByCategoryUid',
    async ({
        categoryUid,
    }) => apiInstance.get(
        '/outdoor-bar-articles',
        {
            'filters[category][slug][$eq]': categoryUid,
            'populate[images][fields][0]': 'url',
            'populate[category][fields]': '*',
        },
        GetOutdoorBarArticleCardsByCategoryUidApiResponseSchema,
    ),
);
